import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IDialogContentComponent } from '../../modal-dialog/modal-dialog.service';
import { ShareByAppComponent, ShareEntityPopupInput, ShareEntityPopupResult } from './components/share-by-app/share-by-app.component';
import { ShareByEmailComponent, ShareStudyByEmailPopupResult } from './components/share-by-email/share-by-email.component';
import { ShareByReferingVetComponent, ShareByReferingVetPopupResult } from './components/share-by-refering-vet/share-by-refering-vet.component';

@Component({
  selector: 'app-share-study',
  templateUrl: './share-study.component.html',
  styleUrls: ['./share-study.component.scss']
})
export class ShareStudyComponent implements OnInit, IDialogContentComponent<ShareStudyByEmailPopupResult | ShareEntityPopupResult | ShareByReferingVetPopupResult, ShareEntityPopupInput> {

  @ViewChild(ShareByEmailComponent) shareByEmailComponent: ShareByEmailComponent;
  @ViewChild(ShareByAppComponent) shareByAppComponent: ShareByAppComponent;
  @ViewChild(ShareByReferingVetComponent) shareByReferingVetComponent: ShareByReferingVetComponent;

  input?: ShareEntityPopupInput | undefined;
  ShareModeEnum = ShareModeEnum;
  shareTypeFormControl: FormControl = new FormControl(ShareModeEnum.ByEmail);

  getResult(): ShareStudyByEmailPopupResult | ShareEntityPopupResult | ShareByReferingVetPopupResult {
    if ( this.shareTypeFormControl.value === ShareModeEnum.ByApp) {
      return this.shareByAppComponent.getResult();
    } else if (this.shareTypeFormControl.value === ShareModeEnum.ByReferingVet) {
      return this.shareByReferingVetComponent.getResult();
    } else {
      return this.shareByEmailComponent.getResult();
    }
  }

  isDisabled(): boolean {
    if ( this.shareTypeFormControl.value === ShareModeEnum.ByApp) {
      return this.shareByAppComponent.isDisabled();
    } else if (this.shareTypeFormControl.value === ShareModeEnum.ByReferingVet) {
      return this.shareByReferingVetComponent.isDisabled();
    } else {
      return this.shareByEmailComponent.isDisabled();
    }
  }

  ngOnInit(): void {
  }

}

export enum ShareModeEnum {
  ByApp,
  ByEmail,
  ByReferingVet
}
